/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../onboard/business/categories';
import '../../onboard/business/subcategories';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "EsBusiness": {
                "fields": {
                  "category": {
                    "type": ".squareup.onboard.business.categories.BusinessCategory",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subCategory": {
                    "type": ".squareup.onboard.business.subcategories.BusinessSubcategory",
                    "id": 2,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "addressToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "websiteUrl": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "vat": {
                    "type": ".squareup.onboarding.business.common.Vat",
                    "id": 7,
                    "rule": "optional"
                  },
                  "taxIdentificationNumber": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "merchantAnalytic": {
                    "type": ".squareup.onboarding.business.common.MerchantAnalytic",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "enteredBeneficialOwnerInformation": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "countryOfRegistration": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "tradingName": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.EsBusiness) {
  $root.addJSON(jsonData);
}

/**
 * Represents a business entity in Spain.
 *
 * SOURCE EsBusiness @ squareup/onboarding/business/es.proto at 14:1
 */
export const EsBusiness = $root.lookupType('squareup.onboarding.business.EsBusiness');
fixType(EsBusiness);
Builder.createAndAttachToType(EsBusiness);